import * as React from "react";
const SvgPersonalInformation = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "personal_information_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "personal_information_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.15 12.81a6 6 0 1 0-6.87.2 10 10 0 0 0-6.22 8.16 1 1 0 0 0 1 1.12 1 1 0 0 0 1-.87A8 8 0 0 1 13.29 15h3.54a10 10 0 0 0-3.68-2.19M9.57 4a4 4 0 1 1-4 4 4 4 0 0 1 4-4",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("rect", {
	width: 9,
	height: 2,
	x: 14,
	y: 17,
	rx: 1,
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("rect", {
	width: 6,
	height: 2,
	x: 14,
	y: 20,
	rx: 1,
	style: { fill: "currentColor" }
}))));
export default SvgPersonalInformation;
